module.exports = __webpack_public_path__ + "static/media/status-complete-email-product.6c2baff2.svg";